
<template>
    <div class="card">
      <div class="card-content">
        <div class="row white-text">
          <div class="col s12 m3" data-aos="flip-left">
            <img class="circle responsive-img" src="/static/ed_moi_1.jpg" alt="photo du créateur du site">
          </div>
          <div class="col s12 m8">
            <span class="card-title"><strong>Qui suis-je ?</strong></span>
            <p>
              Enchanté, je m’appelle Pierre-Louis Despaigne ! J'ai un Master 1 d'Informatique (Bac +4) et je suis un développeur web freelance.
              Mon travail est de vous <strong>conseiller</strong> et de vous <strong>accompagner</strong> tout au long de la réalisation de votre site internet.
              Vous exprimez vos besoins et vos envies, et <strong>je m'occupe de tout</strong> !
            </p>
            <ul>
              <li>Écriture du contenu (Français et Anglais)</li>
              <li>Design des pages</li>
              <li>Développement du site</li>
              <li>Déploiement sur internet</li>
            </ul>
            <p>À chaque étape nous restons en <strong>contact</strong> pour garantir que la réalisation avance dans la bonne direction.</p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'sitesectionme'
  // props: {
  //   subtitle: {
  //     default: 'Title',
  //     type: String
  //   },
  //   textBefore: {
  //     default: 'Text',
  //     type: String
  //   },
  //   imgPath: {
  //     default: '',
  //     type: String
  //   },
  //   text: {
  //     default: 'Text',
  //     type: String
  //   }
  // }
}
</script>

<style scoped>
strong {
    font-weight: bolder;
}
.section-card{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.section-title{
    align-self: flex-start;
}
ul {
  padding-left: 16px;
}
ul > li {
  list-style: square inside;
}
</style>



// WEBPACK FOOTER //
// src/components/Sitesectionme.vue